import MultiStateItem from "../../../core/items/MultiStateItem";
import { defaultBigPoeBottle } from "./BigPoeBottleItem";
import { defaultBlueFireBottle } from "./BlueFireBottleItem";
import { defaultBugBottle } from "./BugBottleItem";
import { defaultEmptyBottle } from "./EmptyBottle";
import OotItem from "./OotItem";

export interface MultiBottleItemProps {
    slotNumber: number
}

const MultiBottleItem = (props: MultiBottleItemProps) => {

    let bottles = [defaultEmptyBottle,
        defaultBugBottle,
        defaultBlueFireBottle,
        defaultBigPoeBottle
    ]

    let id = "Bottle " + props.slotNumber

    return <OotItem id={id}>
        {({ updateOotItem, item }) => {

            return <MultiStateItem
                id={id}
                items={bottles}
                updateItem={updateOotItem}
                item={item}
                isMajor
            ></MultiStateItem>

        }}</OotItem>
}

export default MultiBottleItem;